import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Badge,
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";

const ModerationDetailsModal = ({ isOpen, toggle, banner }) => {
  const moderation = banner?.moderation;

  const getModerationResultBadge = (result) => {
    if (!result) return null;
    const resultLower = result.toLowerCase();
    if (resultLower === "pass") {
      return <Badge color="success" className="px-3 py-2">Pass</Badge>;
    } else if (resultLower === "fail") {
      return <Badge color="danger" className="px-3 py-2">Fail</Badge>;
    }
    return <Badge color="secondary" className="px-3 py-2">{result}</Badge>;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle} className="bg-info text-white">
        <i className="mdi mdi-shield-check me-2"></i>Moderation Details
        {banner?.id && <span className="ms-2 small">(Banner ID: {banner.id})</span>}
      </ModalHeader>
      <ModalBody>
        {!moderation ? (
          <div className="text-center py-5">
            <i className="mdi mdi-information-outline" style={{ fontSize: "3rem", color: "#6c757d" }}></i>
            <p className="mt-3 text-muted">No moderation information available for this banner</p>
          </div>
        ) : (
          <Card className="shadow-sm">
            <CardBody className="p-4">
              <Row className="g-3">
                <Col xs={12}>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0 fw-bold">
                      <i className="mdi mdi-shield-check me-2"></i>Moderation Result
                    </h6>
                    {getModerationResultBadge(moderation.moderation_result)}
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <label className="form-label text-muted small mb-1">Moderation Type</label>
                    <div className="fw-semibold">
                      {moderation.moderation_type || "-"}
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <label className="form-label text-muted small mb-1">Moderation Reason</label>
                    <div className="fw-semibold">
                      {moderation.moderation_reason || "-"}
                    </div>
                  </div>
                </Col>

                {moderation.moderation_details && (
                  <Col xs={12}>
                    <div className="mb-3">
                      <label className="form-label text-muted small mb-1">Moderation Details</label>
                      <div className="p-3 bg-light rounded border">
                        {moderation.moderation_details}
                      </div>
                    </div>
                  </Col>
                )}

                {moderation.moderation_proof && Object.keys(moderation.moderation_proof).length > 0 && (
                  <Col xs={12}>
                    <div className="mb-3">
                      <label className="form-label text-muted small mb-1">Moderation Proof</label>
                      <div className="p-3 bg-light rounded border">
                        <pre className="mb-0 small" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                          {JSON.stringify(moderation.moderation_proof, null, 2)}
                        </pre>
                      </div>
                    </div>
                  </Col>
                )}

                {banner?.created_at && (
                  <Col md={6}>
                    <div className="mb-3">
                      <label className="form-label text-muted small mb-1">Created At</label>
                      <div className="small">{formatDate(banner.created_at)}</div>
                    </div>
                  </Col>
                )}

                {banner?.updated_at && (
                  <Col md={6}>
                    <div className="mb-3">
                      <label className="form-label text-muted small mb-1">Updated At</label>
                      <div className="small">{formatDate(banner.updated_at)}</div>
                    </div>
                  </Col>
                )}
              </Row>
            </CardBody>
          </Card>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          <i className="mdi mdi-close me-2"></i>Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModerationDetailsModal;

